import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { EntitiesAccessRightsUpdateChange } from "api/generated/model";

import { AccessRightChanges } from "./accessRightChanges";
import { accessRightLabel } from "./labels";

export function successMessage(
    t: TFunction,
    change: EntitiesAccessRightsUpdateChange,
    changes: AccessRightChanges
) {
    const users = t("ControlEntities_AssignUsers_UserCount", {
        count: changes.entityCountByUser.size,
    });
    const entities = t("ControlEntities_AssignUsers_EntityCount", {
        count: changes.changedEntityCount,
    });
    switch (change.type) {
        case "grant":
            return t("ControlEntities_AssignUsers_Granted", {
                users,
                right: accessRightLabel(t, change.right),
                entities,
            });
        case "revoke":
            return t("ControlEntities_AssignUsers_Removed", {
                users,
                entities,
            });
        default:
            return assertNever(change);
    }
}
